import { FileType, LegacyUploadFileMetadata } from './types';

// Patterns to match in filenames (case-insensitive)
const FILE_TYPE_PATTERNS: Record<FileType, string[]> = {
  [FileType.TMS]: ['tms'],
  [FileType.TRANSPORT_ORDER]: ['transport', 'order'],
  [FileType.ADD]: ['add'],
  [FileType.UNKNOWN]: [],
};

// Upload order priority (lower = first)
const FILE_TYPE_ORDER: Record<FileType, number> = {
  [FileType.TMS]: 1,
  [FileType.TRANSPORT_ORDER]: 2,
  [FileType.ADD]: 3,
  [FileType.UNKNOWN]: 4,
};

// Display labels for dropdown (legacy)
export const LEGACY_FILE_TYPE_LABELS: Record<FileType, string> = {
  [FileType.TMS]: 'TMS',
  [FileType.TRANSPORT_ORDER]: 'Transport Order',
  [FileType.ADD]: 'Add',
  [FileType.UNKNOWN]: 'Unknown',
};

/**
 * Detect file type based on filename patterns (legacy - for LPI Reports)
 */
export const detectFileType = (filename: string): FileType => {
  const lowerName = filename.toLowerCase();

  // Check patterns in priority order
  if (FILE_TYPE_PATTERNS[FileType.TMS].some((p) => lowerName.includes(p))) {
    return FileType.TMS;
  }
  if (FILE_TYPE_PATTERNS[FileType.TRANSPORT_ORDER].some((p) => lowerName.includes(p))) {
    return FileType.TRANSPORT_ORDER;
  }
  if (FILE_TYPE_PATTERNS[FileType.ADD].some((p) => lowerName.includes(p))) {
    return FileType.ADD;
  }

  return FileType.UNKNOWN;
};

/**
 * Sort files by type in upload order: TMS -> Transport Order -> Add -> Unknown (legacy - for LPI Reports)
 */
export const sortFilesByType = (
  files: LegacyUploadFileMetadata[]
): LegacyUploadFileMetadata[] =>
  [...files].sort((a, b) => FILE_TYPE_ORDER[a.type] - FILE_TYPE_ORDER[b.type]);

/**
 * Create file metadata with auto-detected type (legacy - for LPI Reports)
 */
export const createFileMetadata = (file: File): LegacyUploadFileMetadata => {
  const detectedType = detectFileType(file.name);
  return {
    file,
    type: detectedType,
    detectedType,
  };
};

/**
 * Get all file type options for dropdown (legacy - for LPI Reports)
 */
export const getFileTypeOptions = (): { value: FileType; label: string }[] =>
  Object.values(FileType).map((type) => ({
    value: type,
    label: LEGACY_FILE_TYPE_LABELS[type],
  }));
